import {createTheme, ThemeOptions} from "@mui/material";
import {DEFAULT_THEME_OPTIONS} from "../shared/colors";

export const COLOR_PRIMARY = "#000066";
export const COLOR_SECONDARY = "#ff6600";

export const THEME_OPTIONS: ThemeOptions = {
  ...DEFAULT_THEME_OPTIONS,
  typography: {
    ...DEFAULT_THEME_OPTIONS.typography,
    fontSize: 17,
  },
  palette: {
    primary: {
      main: COLOR_PRIMARY,
      contrastText: "#fff",
    },
    secondary: {
      main: COLOR_SECONDARY,
      contrastText: "#fff",
    },
  }
};

export const THEME = createTheme(THEME_OPTIONS);
